import { useTranslation } from 'react-i18next'
import DividerLine from '../DividerLine'
import Question from './Question'

const Faq = () => {
    const { t } = useTranslation()

    return (
        <div>
            <DividerLine mt={'10'} mb={'10'}/>
            <div className='px-10'>
                <p className='text-3xl px-4 font-semibold mb-4'>{ t('faq_title') }</p>
                <section className='space-y-4'>
                    <Question question={ t('faq_q1') } answer={ t('faq_a1') }/>
                    <Question question={ t('faq_q2') } answer={ t('faq_a2') } />
                    <Question question={ t('faq_q3') } answer={ t('faq_a3') } />
                    <Question question={ t('faq_q4') } answer={ t('faq_a4') } />
                    <Question question={ t('faq_q5') } answer={ t('faq_a5') } />
                </section>
            </div>
        </div>
    )
}

export default Faq